'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _label = require('../base/label');

var _label2 = _interopRequireDefault(_label);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function (_BaseLabel) {
  (0, _inherits3.default)(Label, _BaseLabel);

  function Label(data, type) {
    (0, _classCallCheck3.default)(this, Label);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Label.__proto__ || (0, _getPrototypeOf2.default)(Label)).call(this, data, type));

    _this.resetDefault(data);
    return _this;
  }

  (0, _createClass3.default)(Label, [{
    key: 'resetDefault',
    value: function resetDefault(data) {
      !data._allFromStore && (data._allFromStore = false);
    }
  }, {
    key: 'setGiftPack',
    value: function setGiftPack(p) {
      var _this2 = this;

      (0, _keys2.default)(p).forEach(function (key) {
        _this2.data[key] = p[key];
      });
      this.resetDefault(this.data);
      this.setTransformedData();
      _util2.default.eventPasser.emit('send-to-order');
    }
  }, {
    key: 'setTransformedData',
    value: function setTransformedData() {
      var data = this.data;
      if (this.type === 'LABEL') {
        var v = _util2.default.clone(data);
        var mode = v.mode;
        // campaign which has not campaign info should display as 'TEXT'
        if (mode === 'CAMPAIGN' && !v.campaign) {
          mode = 'TEXT';
        }
        v.class = 'type-label ';
        switch (mode) {
          case 'TEXT':
            v.rightDesc = '';
            v.class += 'text ';
            v.class += v.valid ? 'full-width' : 'invalid full-width';
            break;
          case 'CAMPAIGN':
            v.rightDesc = v.campaign.linkDesc;
            v.class += 'campaign ';
            if (v.jump === true) {
              v.class += 'link ';
            } else {
              v.class += 'not-jump ';
            }
            if (!v.campaign.fulfilled) {
              v.class += 'not-fulfilled';
            }
            break;
          case 'POSTAGE':
            v.rightDesc = v.postage.linkDesc;
            v.class += 'postage ';
            v.class += 'link ';
            if (!v.postage.fulfilled) {
              v.class += 'not-fulfilled';
            }
            break;
          default:
            v.rightDesc = '';
            v.class += v.valid ? 'full-width' : 'invalid full-width';
        }
        // return v
        this.data.transformedData = v;
      }
      if (this.type === 'GIFT') {
        var labelType = 'type-gift';
        var el = data;
        var campaignInfo = void 0;
        if (!el.campaign || !el.campaign.info) {
          campaignInfo = {
            // type: '赠品',
            // typeBgColor: '#537371',
            // typeColor: '#FFFFFF',
            // summaryColor: '#000'
          };
        } else {
          campaignInfo = el.campaign.info;
        }
        this.data.transformedData = {
          count: el.count,
          link: el.link,
          summary: el.spv.name + ' ' + el.spv.spvDesc,
          summaryColor: '' + campaignInfo.summaryColor,
          type: '' + campaignInfo.type,
          typeBgColor: '' + campaignInfo.typeBgColor,
          typeColor: '' + campaignInfo.typeColor,
          // valid: true,
          rightDesc: el.owned ? el.groupId == 0 || el.groupId ? '换赠品' : el.hasVariants ? '选规格' : '已获得' : '已赠完',
          class: el.owned ? el.hasVariants ? labelType + ' link' : '' + labelType : labelType + ' invalid'
        };
      }
    }
  }]);
  return Label;
}(_label2.default);

exports.default = Label;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/ipos/label.js
// module id = 857
// module chunks = 0